module.exports = __webpack_public_path__ + "img/dink-bedroom-3.5d7db822.jpeg";